export const EVENT_FORMAT_COLORS: Record<string, string> = {
  'Office closure': '#FF7387',
  'In-Person': '#AE99C0',
  Virtual: '#AFD7F2',
  Hybrid: '#FFD58D',
} as const;

export const getEventFormatColor = (formatName?: string | null): string => {
  return EVENT_FORMAT_COLORS[formatName ?? ''] ?? '#EFEFEF';
};
